import { connect } from 'react-redux';
// import { getThreadState } from '../CommentThread/selectors';
import { removeModalsOfType } from '../Modals/redux/actionCreators';
import { ModalType } from '../Modals/redux/types';
const mapStateToProps = (state, ownProps)=>{
    return {};
};
const mapDispatchToProps = (dispatch)=>({
        closeAllCommentModals: ()=>dispatch(removeModalsOfType(ModalType.COMMENT_THREAD))
    });
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=CommentModal.container.js.map